// src/layouts/AdminPortal/DataSourceMonitoring/dataSourceColumns.ts
import { Button} from "antd";
import { SyncOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

export interface DataSource {
  tenant_name: string;
  tenant_email: string;
  connected_source: string;
  type: string;
  last_sync: string;
  status: string;

}
export const getDataSourceColumns = ({
  actionInProgressId,
  handleSyncNow,
  handleViewConnection,
  setSelectedDeleteItem,
  setShowDeleteModal,
}: {
  actionInProgressId: string | null;
  handleSyncNow: (email: string, source: string, tenant: string) => void;
  handleViewConnection: (email: string, source: string) => void;
  setSelectedDeleteItem: (item: any) => void;
  setShowDeleteModal: (open: boolean) => void;
}) => [
  { title: "User", dataIndex: "tenant_name", key: "tenant_name" },
  { title: "Email", dataIndex: "tenant_email", key: "tenant_email" },
  {
    title: "Connected Source",
    dataIndex: "connected_source",
    key: "connected_source",
  },
  { title: "Type", dataIndex: "type", key: "type" },
  { title: "Last Sync", dataIndex: "last_sync", key: "last_sync" },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => (
      <span className={`status-badge status-badge--${status.toLowerCase()}`}>
        {status}
      </span>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    render: (_: any, item: any) => {
      const isDisabled =
        actionInProgressId === `${item.tenant_email}-${item.connected_source}`;

      return (
        <div
          style={{
            display: "flex",
            gap: 8,
            opacity: isDisabled ? 0.5 : 1,
            pointerEvents: isDisabled ? "none" : "auto",
            position: "relative",
            overflow: "visible",
          }}
        >
          <Tippy content="Sync Now" placement="top">
            <Button
              type="text"
              icon={<SyncOutlined />}
              onClick={() =>
                handleSyncNow(
                  item.tenant_email,
                  item.connected_source,
                  item.tenant_name
                )
              }
            />
          </Tippy>

          <Tippy content="View Connection" placement="top">
            <Button
              type="text"
              icon={<EyeOutlined />}
              onClick={() =>
                handleViewConnection(item.tenant_email, item.connected_source)
              }
            />
          </Tippy>

          <Tippy content="Delete Connection" placement="top">
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => {
                setSelectedDeleteItem(item);
                setShowDeleteModal(true);
              }}
            />
          </Tippy>
        </div>
      );
    },
  },
];
